"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryButtonLink = exports.SecondaryButtonExternalLink = exports.PrimaryButtonLink = exports.PrimaryButtonExternalLink = exports.DangerButtonLink = exports.DangerButtonExternalLink = void 0;
var React = _interopRequireWildcard(require("react"));
var _typography = require("../../../typography");
var _buttons = require("../buttons");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var PrimaryButtonLink = exports.PrimaryButtonLink = function PrimaryButtonLink(_ref) {
  var href = _ref.href,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(_typography.Link, {
    href: href
  }, /*#__PURE__*/React.createElement(_buttons.PrimaryButton, {
    onClick: function onClick() {},
    as: 'span'
  }, children));
};
PrimaryButtonLink.displayName = 'PrimaryButtonLink';
var PrimaryButtonExternalLink = exports.PrimaryButtonExternalLink = function PrimaryButtonExternalLink(_ref2) {
  var href = _ref2.href,
    children = _ref2.children;
  return /*#__PURE__*/React.createElement(_typography.ExternalLink, {
    href: href
  }, /*#__PURE__*/React.createElement(_buttons.PrimaryButton, {
    onClick: function onClick() {},
    as: 'span'
  }, children));
};
PrimaryButtonExternalLink.displayName = 'PrimaryButtonExternalLink';
var SecondaryButtonLink = exports.SecondaryButtonLink = function SecondaryButtonLink(_ref3) {
  var href = _ref3.href,
    children = _ref3.children;
  return /*#__PURE__*/React.createElement(_typography.Link, {
    href: href
  }, /*#__PURE__*/React.createElement(_buttons.SecondaryButton, {
    onClick: function onClick() {},
    as: 'span'
  }, children));
};
SecondaryButtonLink.displayName = 'SecondaryButtonLink';
var SecondaryButtonExternalLink = exports.SecondaryButtonExternalLink = function SecondaryButtonExternalLink(_ref4) {
  var href = _ref4.href,
    children = _ref4.children;
  return /*#__PURE__*/React.createElement(_typography.ExternalLink, {
    href: href
  }, /*#__PURE__*/React.createElement(_buttons.SecondaryButton, {
    onClick: function onClick() {},
    as: 'span'
  }, children));
};
SecondaryButtonExternalLink.displayName = 'SecondaryButtonExternalLink';
var DangerButtonLink = exports.DangerButtonLink = function DangerButtonLink(_ref5) {
  var href = _ref5.href,
    children = _ref5.children;
  return /*#__PURE__*/React.createElement(_typography.Link, {
    href: href
  }, /*#__PURE__*/React.createElement(_buttons.DangerButton, {
    onClick: function onClick() {},
    as: 'span'
  }, children));
};
DangerButtonLink.displayName = 'DangerButtonLink';
var DangerButtonExternalLink = exports.DangerButtonExternalLink = function DangerButtonExternalLink(_ref6) {
  var href = _ref6.href,
    children = _ref6.children;
  return /*#__PURE__*/React.createElement(_typography.ExternalLink, {
    href: href
  }, /*#__PURE__*/React.createElement(_buttons.DangerButton, {
    onClick: function onClick() {},
    as: 'span'
  }, children));
};
DangerButtonExternalLink.displayName = 'DangerButtonExternalLink';